import { api } from "./axios";

export const preferencesApi = {
  getPreferences: (userId: number) => api.get(`/preferences/${userId}`),
  updatePreferences: (userId: number, data: any) =>
    api.put(`/preferences/${userId}`, data),
  // exportData: (userId: number) => api.get(`/preferences/export/${userId}`),
};
